import React, { useEffect } from 'react'
import './Career_Container.css'
import Career_Card from '../career_card/Career_Card'
import { useDispatch, useSelector } from 'react-redux'
import { getAllCareers } from '../../../features/career/careerSlice'
import parse from 'html-react-parser'
const Career_Container = () => {

    const data = [
        {
            label: "Jr. H.R. Executive",
            descn: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            label: "Sr. Marketing Executive",
            descn: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            label: "Manager I - Inventory",
            descn: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            label: "Security Analyst",
            descn: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },

    ]
    const dispatch = useDispatch();
    const careers = useSelector((state) => state.career.careers);
    useEffect(() => {
        dispatch(getAllCareers());
    }, [dispatch])


    return (
        <section className='Career_Container'>
            <div className='container'>
                <div className='white_box'>
                    <div className='main_content_div'>
                        {careers && (careers?.map((item, index) => {
                            return (
                                <Career_Card id={item?.id} index={index} label={item?.name} descn={parse(item?.description)} />
                            )
                        }))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Career_Container
